// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MorePosts__posts":"pc_a bhm_rc bhm_qx bhm_xr"};